export { default } from './CopyAddressTo';
export type { CopyAddressType } from './CopyAddressTo';
